module.exports = __webpack_public_path__ + "img/group309.daad799e.png";